/**
 * @generated SignedSource<<8b0312beb618558c4c6befb232201a1c>>
 * @flow
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type PipelineFavoriteInput = {|
  clientMutationId?: ?string,
  favorite: boolean,
  id: string,
|};
export type PipelineFavoriteMutation$variables = {|
  input: PipelineFavoriteInput,
|};
export type PipelineFavoriteMutation$data = {|
  +pipelineFavorite: ?{|
    +pipeline: ?{|
      +favorite: boolean,
    |},
  |},
|};
export type PipelineFavoriteMutation = {|
  response: PipelineFavoriteMutation$data,
  variables: PipelineFavoriteMutation$variables,
|};
*/

var node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "favorite",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PipelineFavoriteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineFavoritePayload",
        "kind": "LinkedField",
        "name": "pipelineFavorite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pipeline",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PipelineFavoriteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "PipelineFavoritePayload",
        "kind": "LinkedField",
        "name": "pipelineFavorite",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Pipeline",
            "kind": "LinkedField",
            "name": "pipeline",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "dc4d8e37dec039208862c23832b4278b",
    "id": null,
    "metadata": {},
    "name": "PipelineFavoriteMutation",
    "operationKind": "mutation",
    "text": "mutation PipelineFavoriteMutation(\n  $input: PipelineFavoriteInput!\n) {\n  pipelineFavorite(input: $input) {\n    pipeline {\n      favorite\n      id\n    }\n  }\n}\n"
  }
};
})();

(node/*: any*/).hash = "21e3f9640ef365d26e3736b56341360d";

module.exports = ((node/*: any*/)/*: Mutation<
  PipelineFavoriteMutation$variables,
  PipelineFavoriteMutation$data,
>*/);
